class CartCoupon extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.input = this.querySelector("input");
    this.status = this.querySelector(".cart-coupon-status");
    this.allowMultiple = this.dataset.multiple === "true";
    this.couponCodes = [];
    this.details = this.querySelector(".mini-cart-coupon-dropdown");
    if (this.details) {
      this.details.addEventListener("toggle", () => {
        if (this.details.open) {
          requestAnimationFrame(() => {
            this.input?.focus();
            this.input?.select();
          });
        }
      });
    }
    this.getCartContents().then((response) => {
      this.couponCodes = this.getExistingCouponCodes(response);
    });
    this.button.addEventListener("click", this.submit.bind(this));
    this.input.addEventListener("keydown", this.submit.bind(this));
  }

  async submit(event) {
    if (event instanceof KeyboardEvent && event.key !== "Enter") {
      return;
    }
    event.preventDefault();
    this.hideStatusMessage();
    const couponsEntered = this.input.value
      .split(",")
      .map((coupon) => coupon.trim().toUpperCase())
      .filter((coupon) => coupon && coupon.length > 0);
    const coupon = couponsEntered.shift();
    if (!coupon) {
      return !1;
    }
    const alreadyApplied = (couponCode) =>
      this.couponCodes.reduce((applied, discount) => {
        return applied || discount.code.toUpperCase() === couponCode;
      }, !1);
    const couponAppliesToCart = (couponCode) =>
      this.couponCodes.reduce((applied, discount) => {
        return (
          applied ||
          (discount.code.toUpperCase() === couponCode &&
            discount.applicable === !0)
        );
      }, !1);
    
    if (coupon && alreadyApplied(coupon)) {
      this.setStatusMessage(cartStrings.couponAlreadyApplied, !0);
      return !1;
    }
    
    if (!this.allowMultiple) {
      this.couponCodes = [];
    }
    
    const newCouponCodes = [
      coupon,
      ...this.couponCodes.map((discount) => discount.code),
    ];
    
    this.setLoading();
    
    fetch(routes.cart_update_url, {
      ...fetchConfig(),
      ...{
        body: JSON.stringify({
          discount: newCouponCodes.join(","),
          sections: this.getSectionsToRender().map(
            (section) => section.section,
          ),
        }),
      },
    })
      .then((response) => response.json())
      .then((response) => {
        this.couponCodes = this.getExistingCouponCodes(response);
        if (coupon) {
          if (couponAppliesToCart(coupon)) {
            this.setStatusMessage(cartStrings.couponSuccess, !0);
            this.input.value = "";
          } else {
            this.setStatusMessage(cartStrings.couponNotApplicable, !1);
          }
        }
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              ?.querySelector(section.selector) ||
            document.getElementById(section.id);
            
          if (!elementToReplace) return; // Validación de seguridad extra

          if (section.id === "header-mini-cart-footer") {
            const minicartCouponEl = elementToReplace.querySelector(".minicart-coupon");
            
            // Solo clonamos si el elemento realmente existe
            if (minicartCouponEl) {
              const couponClone = minicartCouponEl.cloneNode(!0);
              const clonedButton = couponClone.querySelector("button");
              
              if (clonedButton) {
                clonedButton.classList.remove("loading");
                const clonedSpinner = couponClone.querySelector(".button-overlay-spinner");
                if (clonedSpinner) {
                  clonedSpinner.classList.add("hidden");
                }
              }
              
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                response.sections[section.section],
                section.selector,
              );
              
              const newMinicartCouponEl = elementToReplace.querySelector(".minicart-coupon");
              if (newMinicartCouponEl) {
                newMinicartCouponEl.outerHTML = couponClone.outerHTML;
              }
            } else {
              // Si no existe, solo actualizamos el HTML normal
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                response.sections[section.section],
                section.selector,
              );
            }
          } else {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              response.sections[section.section],
              section.selector,
            );
          }
        });
      })
      .catch((error) => {
        console.error("Fetch error capturado:", error);
        this.setStatusMessage(cartStrings.couponError, !1);
      })
      .finally(() => {
        this.removeLoading();
      });
  }

  async getCartContents() {
    let json = {};
    try {
      const response = await fetch(routes.cart_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
      });
      json = await response.json();
    } catch (error) {
      console.error("Error al obtener carrito:", error);
    }
    return json;
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    // Versión segura de la extracción del HTML
    if (!html) return "";
    const parsedDOM = new DOMParser().parseFromString(html, "text/html");
    const element = parsedDOM.querySelector(selector);
    return element ? element.innerHTML : "";
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-page-title-wrap",
        section: document.getElementById("cart-page-title-wrap")?.dataset.id,
        selector: ".page-title-wrap",
      },
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items")?.dataset.id,
        selector: ".js-contents",
      },
      {
        id: "header",
        section: document.getElementById("header")?.dataset.id,
        selector: ".head-slot-cart-link",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer")?.dataset.id,
        selector: ".js-contents",
      },
      { id: "header-mini-cart-content", section: "header-mini-cart-content" },
      { id: "header-mini-cart-footer", section: "header-mini-cart-footer" },
      {
        id: "mobile-dock",
        section: document.getElementById("mobile-dock")?.dataset.id,
        selector: ".head-slot-cart-link",
      },
    ].filter((section) => {
      const element = document.getElementById(section.id);
      return (
        element &&
        (section.selector ? element.querySelector(section.selector) : !0)
      );
    });
  }

  getExistingCouponCodes(response) {
    return response?.discount_codes ?? [];
  }

  hideStatusMessage() {
    this.status.classList.add("hidden");
    this.status.classList.remove(
      ...["form-status-success", "form-status-error"],
    );
    this.status.innerHTML = "";
  }

  setStatusMessage(message, success = !1) {
    this.status.classList.remove(
      ...["hidden", "form-status-success", "form-status-error"],
    );
    this.status.classList.add(
      success ? "form-status-success" : "form-status-error",
    );
    this.status.innerHTML = message;
  }

  setLoading() {
    this.button.classList.add("loading");
    this.button
      .querySelector(".button-overlay-spinner")
      ?.classList.remove("hidden");
  }

  removeLoading() {
    this.button.classList.remove("loading");
    this.button
      .querySelector(".button-overlay-spinner")
      ?.classList.add("hidden");
  }
}
customElements.define("cart-coupon", CartCoupon);